import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export interface IDoneIconProps {
    className?: string;
}

const DoneIcon = (props: IDoneIconProps) => {
    const className = classNames('elc-done-icon', props.className);
    const image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' preserveAspectRatio='none' fill='%23000000' %3E%3Cpath d='M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' /%3E%3C/svg%3E")`;

    return <Icon className={className} size={'large'} image={image} />;
};

export { DoneIcon };
